// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Sk-SkImg-module--cls1--2k_oQ","cls2":"Sk-SkImg-module--cls2--5tPX4 Sk-SkImg-module--cls1--2k_oQ"};